import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { _transformThread } from '../threads';
import { SearchThreadsCollection } from './search-threads.types';

export function searchThreadsReducer(
  state: CollectionStateSlice<SearchThreadsCollection> = {},
  action: CollectionActions<SearchThreadsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'searchThreads') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<SearchThreadsCollection>(
          state,
          transformIntoDocuments(
            result.threads,
            _transformThread,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
